import React, { useEffect, useState } from 'react';
import './index.less';

type sizeType = 'small' | 'medium' | 'default';

interface IProps {
    checked: boolean;
    size?: sizeType;
    /**开关激活背景色 */
    switchActiveBg?: string;
    onChange?: (checked: boolean) => void;
}

const sizeConfig = {
    small: {
        switchWidth: 28,
        switchHeight: 16,
        borderRadius: 8,
        handleSize: 12,
        handlePadding: 2,
    },
    medium: {
        switchWidth: 36,
        switchHeight: 20,
        borderRadius: 10,
        handleSize: 16,
        handlePadding: 2,
    },
    default: {
        switchWidth: 44,
        switchHeight: 22,
        borderRadius: 12,
        handleSize: 18,
        handlePadding: 2,
    },
};

const Switch: React.FC<IProps> = (props) => {
    const { size = 'default', switchActiveBg = '#1677ff', onChange } = props;
    const [checked, setChecked] = useState(props.checked);

    const handleChange = () => {
        const _checked = !checked;
        setChecked(_checked);
        onChange?.(_checked);
    };

    useEffect(() => {
        setChecked(props.checked);
    }, [props.checked]);

    const { switchWidth, switchHeight, borderRadius, handleSize, handlePadding } = sizeConfig[size];

    const switchStyle = {
        width: switchWidth,
        height: switchHeight,
        borderRadius: borderRadius,
        backgroundColor: checked ? switchActiveBg : 'rgba(0, 0, 0, 0.45)',
    };

    const handleStyle = {
        width: handleSize,
        height: handleSize,
        left: checked ? switchWidth - handleSize - handlePadding : handlePadding,
    };
    return (
        <div className="xdesign-switch" onClick={handleChange} style={switchStyle}>
            <div style={handleStyle} className="xdesign-switch__handle"></div>
        </div>
    );
};

export default Switch;
